import { ReactElement, useState } from 'react'
import { useApp } from '../hooks/useApp'
import { useAxios } from '../hooks/useAxios'
import { Box, useTheme } from '@mui/material'
import { PageTitle } from '../components/atoms/PageTitle'
import { lang } from '../utils/lang'
import { now } from '../utils/time'
import { useDevices } from '../hooks/useDevices'
import { Trans, useTranslation } from 'react-i18next'
import { LinkTo } from '../components/atoms/LinkTo'
import { WidgetGrid } from '../components/WidgetGrid'
import { Widget, WidgetData } from '../classes/widgets/Widget'
import { getWidget } from '../classes/widgets'

export function HomePage(): ReactElement {
  const currentTime = now()
  const theme = useTheme()
  const app = useApp()
  const { control } = useDevices()
  const { t } = useTranslation()
  const [widgets, setWidgets] = useState<Widget[]>([])

  // Show only first for now. Later this could be selected using the `page` concept.
  const location = app.locations.length ? app.locations[0] : null

  useAxios<WidgetData[]>({
    disabled: !location,
    url: `/widgets?location=${location && location.id}`,
    onSuccess: data => {
      const widgets = data.map(w => getWidget(w, control, app))
      widgets.forEach(w => w.connectControls(control))
      setWidgets(widgets)
    }
  })

  if (!location) return <></>

  const haveDevices = control.controls('ALL').length > 0
  const noAppliances = widgets.every(w => w.isGeneric())

  return <>
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <PageTitle title=""/>
      <PageTitle title={lang.dayNameShort(currentTime.weekday) + ' ' + lang.dateShort(currentTime)}/>
    </Box>

    <WidgetGrid sx={{ mt: 2, mb: 4 }} widgets={widgets} onRefresh={() => control.refresh()}/>

    {
      // No devices.
      !haveDevices && <>
        <Box sx={{ mt: 8, display: 'flex', justifyContent: 'space-between' }}>
          <Trans>You have no devices.</Trans>
          <LinkTo sx={{ color: theme.palette.statsText.main }} url="/claim" title={t('Add one')}/>
        </Box>
      </>
    }
    {
      // No Appliances.
      haveDevices && noAppliances && <>
        <Box sx={{ mt: 8, display: 'flex', justifyContent: 'space-between' }}>
          <Trans>You don't have any configured appliances yet.</Trans>
          <LinkTo sx={{ color: theme.palette.statsText.main }} url={'/appliances/new'} title={t('Configure')}/>
        </Box>
      </>
    }
  </>
}
